<template>
	<div class="goods-form-wrapper">
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left" v-if="mode === 'create'">
				{{ $t('promo-to-product.buy-condition') }}
			</h4>
			<h4 class="pull-left" v-else>
				{{ $t('promo-to-product.promo') }} - {{newPromo.name}}
			</h4>
			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i
				class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>
		<form>
			<b-container fluid id="newPromoId" class="promotion">
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.comment">{{ $t('promo-to-product.comment') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<b-form-input size="sm" id="comment"
										  v-model="newPromo.comment"
										  name="comment"
										  autocomplete="off"
										  v-validate="validators.comment"
										  :placeholder="$t('promo-to-product.comment')"
							>
							</b-form-input>

						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.start">{{ $t('promo-to-product.start-date') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<masked-input v-model="newPromo.start"
										  mask="11-11-1111"
										  name="start"
										  class="form-control form-control-sm"
										  v-validate="validators.start"
							/>
						</b-col>
					</b-row>
				</b-form-group>

				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.finish">{{ $t('promo-to-product.finish-date') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<masked-input v-model="newPromo.finish"
										  mask="11-11-1111"
										  name="finish"
										  class="form-control form-control-sm"
										  v-validate="validators.finish"
							/>
						</b-col>
					</b-row>
				</b-form-group>

				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.status">{{ $t('promo-to-product.status') }} <span class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<b-form-select v-model="newPromo.status"
										   v-validate="validators.status"
										   :plain="false"
										   name="status"
										   size="sm"
										   :required="true"
										   :text-field="'name'"
										   :value-field="'id'"
							>

								<template slot="first">
									<option :value="null" disabled>
										--{{ $t('promo-to-product.select-status')}}--
									</option>
									<option value="ACTIVE">{{$t('promotionForm.active')}}</option>
									<option value="PENDING">{{$t('promotionForm.pending')}}</option>
									<option value="INACTIVE">{{$t('promotionForm.inactive')}}</option>
									<option value="REJECTED">{{$t('promotionForm.rejected')}}</option>
								</template>
							</b-form-select>
						</b-col>
					</b-row>
				</b-form-group>

				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.name">{{ $t('promo-to-product.name') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<b-form-input size="sm" id="name"
										  v-model="newPromo.name"
										  name="name"
										  autocomplete="off"
										  v-validate="validators.name"
										  :placeholder="$t('promo-to-product.name')"
							>
							</b-form-input>
						</b-col>
					</b-row>
				</b-form-group>
				<!-- <b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.promotionType">{{ $t('promo-to-product.type') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<b-form-select
								v-model="newPromo.promotionType"
								size="sm"
								name="type"
								v-validate="validators.type"
							>
								<option v-for="(selectOption, indexOpt) in promoType"
										:key="indexOpt"
										:value="selectOption.code"
								>
									{{ selectOption.name }}
								</option>
								<template slot="first">
									<option :value="null" disabled>-- {{ $t('promo-to-product.type') }} --</option>
								</template>
							</b-form-select>

						</b-col>
					</b-row>
				</b-form-group> -->
				<b-form-group v-if="newPromo.promotionType ==='X+N' ">
					<b-row class="my-1">
						<b-col sm="3">
						</b-col>
						<b-col sm="4">
							<label>Размер скидки</label>
							<b-input-group append="%" size="sm">
								<b-form-input v-model="newPromo.promoX" autocomplete="off" type="number"></b-form-input>
							</b-input-group>
						</b-col>
						<b-col sm="4">
							<label>Единиц товара</label>
							<b-input-group append="ед / товар" size="sm">
								<b-form-input v-model="newPromo.promoN" autocomplete="off" type="number"></b-form-input>
							</b-input-group>
						</b-col>
					</b-row>
				</b-form-group>

				<!-- <b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.discount">{{ $t('promo-to-product.discount') }} <span
								class="text-danger">*</span> </label>
						</b-col>
						<b-col sm="9">
							<b-form-input size="sm" id="discount"
										  v-model="newPromo.discount"
										  name="discount"
										  autocomplete="off"
										  v-validate="validators.discount"
										  :placeholder="$t('promo-to-product.discount')"
										  type="number"
							>
							</b-form-input>
						</b-col>
					</b-row>
				</b-form-group> -->
                <b-form-group>
                    <b-row>
                        <b-col sm="3">
							<label :for="newPromo">{{ $t('promo-to-product.quantity') }} <span
								class="text-danger">*</span></label>
						</b-col>
                        <b-col sm="9">
                            <b-form-input size="sm" id="name"
										  v-model="newPromo.qty"
										  name="name"
                                          type="number"
										  autocomplete="off"
										  v-validate="validators.qty"
										  :placeholder="$t('promo-to-product.quantity')"
							>
							</b-form-input>
                        </b-col>
                    </b-row>
                </b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.deps">{{ $t('promo-to-product.department') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<!--							<multiselect v-model="newPromo.deps" :options="newPromo.depsArray" :multiple="true"></multiselect>-->
							<multiselect
								v-model="newPromo.deps"
								v-validate="validators.deps"
								:options="listWarehouse"
								:multiple="true"
								name="deps"
								class="is-invalid"
								track-by="id"
								label="name"
								:placeholder="$t('promo-to-product.department')"
							>
							</multiselect>

						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<hr>
					<b-row class="generalTableClass">
						<b-table striped hover :items="newPromo.itemsList" :fields="computedFields">
							<template slot="id" slot-scope="data">
								<!--								{{ data.index + 1 }}-->
								{{ paginate(data.index, searchForm.page, searchForm.limit) }}
							</template>
						</b-table>

						<nav>
							<b-pagination :total-rows="total>0?total:totalForEdit" :per-page="searchForm.limit"
										  v-model="searchForm.page"
										  :prev-text="$t('pagination.prev')"
										  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
						</nav>


						<!--</tbody>-->
						<!--</table>-->

						<b-modal size="lg"
								 hide-footer
								 v-model="childModal"
								 :no-close-on-esc="true"
								 :no-close-on-backdrop="true"
						>
							<div slot="modal-header" class="addItemsModalHeader">
								<!-- SMALL LOADER -->
								<!--<b-spinner
										   small
										   class="ml-2"
										   variant="primary"
										   label="Small Spinner"></b-spinner>-->
								<!-- SMALL LOADER -->
								<button
									type="button"
									class="close"
									data-dismiss="modal"
									aria-label="Close"
									v-b-tooltip.hover title="Отмена"
									@click="closeAddItemsModal"
								>
									<i class="fa fa-times"></i>
								</button>
							</div>
							<AddChildren
								v-if="childModal"
								@success="wrappedItems"
								:newMessForSpisok="newMessForSpisok"
								@setItems="setItems"
								:mode="mode"
								:defaults="newMessForSpisok == 'plus'?newPromo.itemsList: newPromo.secondItemsList"
								@close="childModal = false"
							></AddChildren>
						</b-modal>

					</b-row>
					<b-row
						v-if="mode!=='create' && (this.promotionPlusForUpdate.length>0 ||this.promotionMinusForUpdate.length>0)"
						class="generalTableClass">
						<div style="overflow-y: scroll; max-height: 346px;" class="col-6">
							<h4 style="text-align: center">{{$t('goods.create.title')}}</h4>
							<b-table striped hover :items="promotionPlusForUpdate" :fields="computedFields">
								<template slot="id" slot-scope="data">
									<!--								{{ data.index + 1 }}-->
									{{ paginate(data.index, searchFormPlus.page, searchFormPlus.limit) }}
								</template>
							</b-table>
							<nav>
								<b-pagination :total-rows="totalPlus" :per-page="searchFormPlus.limit"
											  v-model="searchFormPlus.page"
											  :prev-text="$t('pagination.prev')"
											  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
							</nav>
						</div>
						<div style="overflow-y: scroll; max-height: 346px;" class="col-6">
							<h4 style="text-align: center;">{{$t('promo-to-product.delete-item')}}</h4>
							<b-table striped hover :items="promotionMinusForUpdate" :fields="computedFields">
								<template slot="id" slot-scope="data">
									<!--								{{ data.index + 1 }}-->
									{{ paginate(data.index, searchForm.page, searchForm.limit) }}
								</template>
							</b-table>
							<nav>
								<b-pagination :total-rows="totalMinus" :per-page="searchFormMinus.limit"
											  v-model="searchFormMinus.page"
											  :prev-text="$t('pagination.prev')"
											  :next-text="$t('pagination.next')"
											  hide-goto-end-buttons/>
							</nav>

						</div>
					</b-row>
					<div class="row" v-if="mode=='edit'">
						<div class="col-6">
							<b-button type="button"
									  size="sm"
									  variant="success"
									  :disabled="loadingForNewPromo ||dobavitDisabledButton"
									  class="mt-1"
									  @click="dobavitSpisok('plus')">
								<i class="fa fa-plus-circle" aria-hidden="true"></i> {{ $t('goods.create.title') }}

							</b-button>
						</div>
						<div class="col-2">
							<b-button style="color: white"
									  type="button"
									  size="sm"
									  block variant="danger" class="mt-1"
									  :disabled="loadingForNewPromo || nvSpiskaDisabledButton"
									  @click="newSpisok('minus')">
								<i class="fa fa-trash" aria-hidden="true"></i>
								{{$t('promotionForm.devide')}}
							</b-button>
						</div>
						<div class="col-2"></div>
						<div class="col-2">

							<b-button style="color: white"
									  type="button"
									  size="sm"
									  block variant="warning" class="mt-1"
									  :disabled="refreshDisabledButton ||loadingForNewPromo"
									  @click="refreshArrayMap('firstTable')">
								<i class="fa fa-refresh" aria-hidden="true"> <span
									style="font-family: 'Open Sans', sans-serif">{{$t('promotionForm.otmenit')}}</span></i>

							</b-button>
						</div>

					</div>



					<div class="row" v-if="mode=='create'" style="margin-top: 15px	;">
						<div class="col-3">
							<b-button type="button"
									  size="sm"
									  variant="success"
									  :disabled="loadingForNewPromo ||dobavitDisabledButton"
									  class="mt-1"
									  @click="dobavitSpisok('plus')">
								<i class="fa fa-plus-circle" aria-hidden="true"></i> {{ $t('goods.create.title') }}

							</b-button>
						</div>
						<div class="col-2">
							<b-button style="color: white"
									  type="button"
									  size="sm"
									  block variant="danger" class="mt-1"
									  :disabled="loadingForNewPromo || nvSpiskaDisabledButton"
									  @click="newSpisok('minus')">
								<i class="fa fa-trash" aria-hidden="true"></i>
								{{$t('promotionForm.devide')}}
							</b-button>
						</div>
						<div class="col-4"></div>
						<div class="col-2">

							<b-button style="color: white"
									  type="button"
									  size="sm"
									  block variant="warning" class="mt-1"
									  :disabled="refreshDisabledButton ||loadingForNewPromo"
									  @click="refreshArrayMap('firstTable')">
								<i class="fa fa-refresh" aria-hidden="true"> <span
									style="font-family: 'Open Sans', sans-serif"> {{$t('promotionForm.otmenit')}}</span></i>

							</b-button>
						</div>

					</div>
					<br>
					<br>
					<br>
					<h4  v-if="mode === 'create'" style="font-weight: bold">
						{{ $t('promo-to-product.get-condition') }}
					</h4>
					<hr border="">
					<!-- second Table -->
					<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.discount">{{ $t('promo-to-product.discount') }} <span
								class="text-danger">*</span> </label>
						</b-col>
						<b-col sm="9">
							<b-form-input size="sm" id="discount"
										  v-model="newPromo.discount"
										  name="discount"
										  autocomplete="off"
										  v-validate="validators.discount"
										  :placeholder="$t('promo-to-product.discount')"
										  type="number"
							>
							</b-form-input>
						</b-col>
					</b-row>
				</b-form-group>
					<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.promotionType">{{ $t('promo-to-product.type') }} <span
								class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<b-form-select
								v-model="newPromo.promotionType"
								size="sm"
								name="type"
								v-validate="validators.type"
							>
								<option
								 v-for="(selectOption, indexOpt) in secondPromoType"
										:key="indexOpt"
										:value="selectOption.code"
								>
									{{ selectOption.name }}
								</option>
								<template slot="first">
									<option :value="null" disabled>-- {{ $t('promo-to-product.type') }} --</option>
								</template>
							</b-form-select>

						</b-col>
					</b-row>
				</b-form-group>
					<b-form-group>
						<b-row>
							<b-col sm="3">
								<label :for="newPromo
">{{ $t('promo-to-product.quantity') }} <span
									class="text-danger">*</span></label>
							</b-col>
							<b-col sm="9">
								<b-form-input size="sm" id="name"
											  v-model="newPromo.getQty"
											  name="name"
											  type="number"
											  autocomplete="off"
											  v-validate="validators.getQty"
											  :placeholder="$t('promo-to-product.quantity')"
								>
								</b-form-input>
							</b-col>
						</b-row>
					</b-form-group>
						<br><br>
						<!-- second-table -->

						<b-row class="generalTableClass">
						<b-table striped hover :items="newPromo.secondItemsList" :fields="computedFields">
							<template slot="id" slot-scope="data">
								<!--								{{ data.index + 1 }}-->
								{{ paginate(data.index, searchSecondForm.page, searchSecondForm.limit) }}
							</template>
						</b-table>

						<nav>
							<b-pagination :total-rows="secondPagTotal>0 ? secondPagTotal: secondTotalForEdit" :per-page="searchSecondForm.limit"
										  v-model="searchSecondForm.page"
										  :prev-text="$t('pagination.prev')"
										  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
						</nav>


						<!--</tbody>-->
						<!--</table>-->

					</b-row>
						<b-row
						v-if="mode!=='create' && (this.promotionSecondPlusForUpdate.length>0 ||this.promotionSecondMinusForUpdate.length>0)"
						class="generalTableClass">
						<div style="overflow-y: scroll; max-height: 346px;" class="col-6">
							<h4 style="text-align: center">{{$t('goods.create.title')}}</h4>
							<b-table striped hover :items="promotionSecondPlusForUpdate" :fields="computedFields">
								<template slot="id" slot-scope="data">
									<!--								{{ data.index + 1 }}-->
									{{ paginate(data.index, searchSecondFormPlus.page, searchSecondFormPlus.limit) }}
								</template>
							</b-table>
							<nav>
								<b-pagination :total-rows="secondTotalPlus" :per-page="searchSecondFormPlus.limit"
											  v-model="searchSecondFormPlus.page"
											  :prev-text="$t('pagination.prev')"
											  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
							</nav>
						</div>
						<div style="overflow-y: scroll; max-height: 346px;" class="col-6">
							<h4 style="text-align: center;">{{$t('promo-to-product.delete-item')}}</h4>
							<b-table striped hover :items="promotionSecondMinusForUpdate" :fields="computedFields">
								<template slot="id" slot-scope="data">
									<!--								{{ data.index + 1 }}-->
									{{ paginate(data.index, searchSecondFormMinus.page, searchSecondFormMinus.limit) }}
								</template>
							</b-table>
							<nav>
								<b-pagination :total-rows="secondTotalMinus" :per-page="searchSecondFormMinus.limit"
											  v-model="searchSecondFormMinus.page"
											  :prev-text="$t('pagination.prev')"
											  :next-text="$t('pagination.next')"
											  hide-goto-end-buttons/>
							</nav>

						</div>
					</b-row>
					<div class="row" v-if="mode=='edit'">
						<div class="col-6">
							<b-button type="button"
									  size="sm"
									  variant="success"
									  :disabled="loadingForNewPromo ||dobavitDisabledButton"
									  class="mt-1"
									  @click="dobavitSpisok('secondSpisok')">
								<i class="fa fa-plus-circle" aria-hidden="true"></i> {{ $t('goods.create.title') }}

							</b-button>
						</div>
						<div class="col-2">
							<b-button style="color: white"
									  type="button"
									  size="sm"
									  block variant="danger" class="mt-1"
									  :disabled="loadingForNewPromo || nvSpiskaDisabledButton"
									  @click="newSpisok('secondMinus')">
								<i class="fa fa-trash" aria-hidden="true"></i>
								{{$t('promotionForm.devide')}}
							</b-button>
						</div>
						<div class="col-2"></div>
						<div class="col-2">

							<b-button style="color: white"
									  type="button"
									  size="sm"
									  block variant="warning" class="mt-1"
									  :disabled="refreshDisabledButton ||loadingForNewPromo"
									  @click="refreshArrayMap('secondTable')">
								<i class="fa fa-refresh" aria-hidden="true"> <span
									style="font-family: 'Open Sans', sans-serif">{{$t('promotionForm.otmenit')}}</span></i>

							</b-button>
						</div>

					</div>


                        <!-- get Y  buttonlar -->
                    	<div class="row" v-if="mode=='create'" style="margin-top: 15px	;">
						<div class="col-3">
							<b-button type="button"
									  size="sm"
									  variant="success"
									  :disabled="loadingForNewPromo || dobavitDisabledButtonSecond || newPromo.itemsList.length<=0"
									  class="mt-1"
									  @click="dobavitSpisok('secondSpisok')">
								<i class="fa fa-plus-circle" aria-hidden="true"></i> {{ $t('goods.create.title') }}

							</b-button>
						</div>
						<div class="col-2">
							<b-button style="color: white"
									  type="button"
									  size="sm"
									  block variant="danger" class="mt-1"
									  :disabled="loadingForNewPromo || nvSpiskaDisabledButtonSecond "
									  @click="newSpisok('secondMinus')">
								<i class="fa fa-trash" aria-hidden="true"></i>
								{{$t('promotionForm.devide')}}
							</b-button>
						</div>
						<div class="col-4"></div>
						<div class="col-2">

							<b-button style="color: white"
									  type="button"
									  size="sm"
									  block variant="warning" class="mt-1"
									  :disabled="refreshDisabledButtonSecond ||loadingForNewPromo"
									  @click="refreshArrayMap('secondTable')">
								<i class="fa fa-refresh" aria-hidden="true"> <span
									style="font-family: 'Open Sans', sans-serif"> {{$t('promotionForm.otmenit')}}</span></i>

							</b-button>
						</div>

					</div>

				</b-form-group>
			</b-container>

			<div class="modal-actions">
				<b-row class="align-items-center" style="padding-bottom: 10px">
					<b-col cols="6" class="mb-3 mb-xl-0" style="padding-top: 45px;">
						<b-row>
							<b-col cols="5">
								<b-button block size="sm"
										  type="button"
										  @click="cancel"
										  :disabled="loadingForNewPromo"
										  variant="outline-danger">{{
									$t('cancel') }}
								</b-button>
							</b-col>
							<b-col cols="5">
								<b-button block type="button"
										  size="sm"
										  @click="create"
										  :disabled="loadingForNewPromo"
										  variant="primary">{{ $t('save')
									}}
								</b-button>
							</b-col>
							<b-col cols="2">
								<!-- SMALL LOADER -->
								<b-spinner v-if="loadingForNewPromo"
										   small
										   class="ml-2"
										   variant="primary"
										   label="Small Spinner"></b-spinner>
								<!-- SMALL LOADER -->
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>

		</form>
	</div>
</template>

<script>
	import AddChildren from "./AddChildren";
	import {validators} from "../mixins/validators";
	import PromoService from "../../../../services/promo.service";
	import MaskedInput from 'vue-masked-input'
	import {mapGetters, mapActions, mapState} from 'vuex'
	import Multiselect from 'vue-multiselect'

	export default {
		name: 'NewPromo',
		props: {
			mode: {
				type: String,
				default: 'create'
			},
			edit: {
				type: Object,
				default: null
			},
			totalForEdit: {
				type: Number,
				default: 0
			},
			secondTotalForEdit: {
				type: Number,
				default: 0
			}


		},
		mixins: [validators],
		data() {
			return {
				computedFields: [
					{
						key: 'id',
						label: '№',
						'class': 'width8_wordBreak',
						sortable: true
					},
					{
						key: 'artikul',
						label: this.$t('goods.artikul'),
						'class': 'incomeItemArtikul',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'colorName',
						label: this.$t('goods.color'),
						'class': 'incomeItemArtikul',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'name',
						label: this.$t('incomes.create.product'),
						'class': 'not-first',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'size',
						label: this.$t('goods.size'),
						'class': 'incomeItemSize',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'barcode',
						label: this.$t('goods.barcode'),
						'class': 'td-20',
						sortable: true,
						visible: true,
						changebale: true
					}
				],
				searchCollect: {
					plus: [],
					minus: [],
				},
				secondSearchCollect: {
					plus: [],
					minus: []
				},
				mapIds: {
					plusIds: [],
					minusIds: []
				},
				secondMapIds: {
					plusIds: [],
					minusIds: []
				},
				totalPlus: 0,
				totalMinus: 0,
				secondTotalPlus: 0,
				secondTotalMinus: 0,
				nvSpiskaDisabledButton: true,
				nvSpiskaDisabledButtonSecond: true,
				dobavitDisabledButton: false,
				dobavitDisabledButtonSecond: false,
				refreshDisabledButton: true,
				refreshDisabledButtonSecond: true,
				check: false,
				total: 0,
				secondPagTotal: 0,
				newMessForSpisok: '',
				responseArray: [],
				createPromo: {
					comment: '',
					start: '',
					finish: '',
					status: null,
					itemsList: [],
					selectedIds: [],
					itemsUnnecessary: [],
					secondItemsUnnecessary: [],
					name: '',
					promotionType: null,
					discount: '',
					deps: [],
					depsArray: [],
					promoX: 0,
					promoN: 0,

				},
				searchForm: {
					page: 1,
					limit: 20,
				},
				searchFormPlus: {
					page: 1,
					limit: 20,
				},
				searchFormMinus: {
					page: 1,
					limit: 20,
				},
				searchSecondForm: {
					page: 1,
					limit: 20,
				},
				searchSecondFormPlus: {
					page: 1,
					limit: 20,
				},
				searchSecondFormMinus: {
					page: 1,
					limit: 20,
				},
				depsArray: [],
				newPromo: null,
				promotionPlusForUpdate: [],
				promotionMinusForUpdate: [],
				promotionSecondPlusForUpdate: [],
				promotionSecondMinusForUpdate: [],
				childModal: false,
				loadingForNewPromo: false
			}
		},
		methods: {
			...mapActions('promo', ['fetchDepartment', 'searchDoubleDiscountStore']),
			...mapActions('references', ['getReferenceChildren']),
			...mapActions('departments', ['fetchMyDepartments']),

			refreshArrayMap(table) {
				if (this.mode == 'create') {
					if(table == 'firstTable') {
						this.searchCollect.plus = [];
						this.searchCollect.minus = [];
							PromoService.savePromotionDoubleArray({}, this.searchForm, this.check).then(response => {
							if (response.data == 'success') {
								this.newPromo.itemsList = [];
								this.total = 0;
								this.dobavitDisabledButton = false;
								this.nvSpiskaDisabledButton = true;
							}
						})
					}
					if(table == 'secondTable') {
						this.secondSearchCollect.plus = [];
						this.secondSearchCollect.minus = [];
							PromoService.savePromotionDoubleArray({}, this.searchSecondForm, this.check).then(response => {
							if (response.data == 'success') {
								this.newPromo.secondItemsList = [];
								this.secondPagTotal = 0
								this.dobavitDisabledButtonSecond = false;
								this.nvSpiskaDisabledButtonSecond = true;
							}
						})
					}


				}
				if (this.mode == 'edit') {
					if(table == 'firstTable') {
						this.promotionMinusForUpdate = [];
						this.promotionPlusForUpdate = [];
						this.totalMinus = 0;
						this.totalPlus = 0;
					}
					// get y
					if(table == 'secondTable') {
						this.promotionSecondMinusForUpdate = [];
						this.promotionSecondPlusForUpdate = [];
						this.secondTotalMinus = 0;
						this.secondTotalPlus = 0;
					}


				}
			},
			cancel() {
				this.$emit('close', true);
			},
			dobavitSpisok(newMessSpisok) {
				this.childModal = true;
				this.newMessForSpisok = newMessSpisok;
			},
			newSpisok(newMessSpisok) {
				this.childModal = true;
				this.newMessForSpisok = newMessSpisok;
			},
			paginate(index, page_size, page_number) {
				--page_size;
				return (page_number * page_size) + index + 1;
			},
			async create() {
				this.$validator.validate().then(valid => {
					if (valid) {
						let formInput = {
							comment: this.newPromo.comment,
							start: this.newPromo.start,
							finish: this.newPromo.finish,
							status: this.newPromo.status,
							itemIds: this.newPromo.selectedIds,
							itemsUnnecessary: this.newPromo.itemsUnnecessary,
                            quantity: this.newPromo.qty,
							name: this.newPromo.name,
							departmentIds: []
						}
						this.newPromo.deps.forEach(deps => {
							formInput.departmentIds.push(deps.id)
						})
						let map = {
							plus: this.searchCollect.plus,
							minus: this.searchCollect.minus,
						}
						let secondFormInput = {
							promotionType: this.newPromo.promotionType === "PERCENTAGE" ? "%" : this.newPromo.promotionType,
							discount: this.newPromo.discount,
							itemsUnnecessary: this.newPromo.secondItemsUnnecessary,
							quantity: this.newPromo.getQty,
							map: {
								plus: this.secondSearchCollect.plus,
								minus: this.secondSearchCollect.minus,
							}
						}
						formInput.map = map;
						formInput.promotionDto= secondFormInput
						if (this.newPromo.id)
							formInput.id = this.newPromo.id
							this.loadingForNewPromo = true;
						if (this.mode == 'create') {
							PromoService.addSecondPromo(formInput).then(response => {
								this.loadingForNewPromo = false;
								this.$emit('success', true);
							}).catch(error => {
								this.loadingForNewPromo = false;
								this.$vs.notify({
									text: 'Хатолик йуз берди, бир оздан сонг яна уриниб коринг',
									color: 'warning',
									icon: 'close',
									position: 'top-right'
								});
								this.$emit('success', true);
							});
						}
						if (this.mode == 'edit') {
							if (this.newPromo.promoGet.id)
							formInput.promotionDto.id = this.newPromo.promoGet.id
							this.loadingForNewPromo = true;
							formInput.mapIds = this.mapIds;
							formInput.promotionDto.mapIds = this.secondMapIds;
							PromoService.buyXgetYUpdateFinished(formInput).then(response => {
								if (response.data == 'success') {
									this.$emit('success', true);
								}
								this.childModal = false;
							})
						}

					} else {
						// Object.keys(this.validationFields).some(key => {
						// 	this.validationFields[key].touched = true;
						// 	this.validationFields[key].dirty = true;
						// 	this.validationFields[key].changed = true;
						// });

						this.$vs.notify({
							title: this.$t('words.error'),
							text: 'Заполните все обязательное поле',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					}
				});
				return false;
			},
			setItems(el) {
				if (this.newMessForSpisok == 'plus') {
					this.newPromo.selectedIds = []
				}
				if (this.newMessForSpisok == 'minus') {
					this.newPromo.itemsUnnecessary = [];
				}
				if (this.newMessForSpisok == 'secondSpisok') {
				}
				if (this.newMessForSpisok == 'secondMinus') {
					this.newPromo.secondItemsUnnecessary = [];
				}
				el.forEach(element => {
					if (!this.newPromo.selectedIds.includes(element.wrappedId) && this.newMessForSpisok == 'plus') {
						this.newPromo.selectedIds.push(element.wrappedId)
					}
					if (!this.newPromo.selectedIds.includes(element.wrappedId) && this.newMessForSpisok == 'minus') {
						this.newPromo.itemsUnnecessary.push(element.wrappedId)
					}
				});
			},

			async wrappedItems(el, search) {
				if (this.mode == 'create') {
					if (this.newMessForSpisok == 'plus') {
						this.newPromo.selectedIds = []
						this.newMessForSpisok == ''
						this.check = true;
						await this.searchCollect.plus.push(search);
					}
					if (this.newMessForSpisok == 'minus') {
						this.newPromo.itemsUnnecessary = []
						this.newMessForSpisok == ''
						this.check = false;
						this.searchCollect.minus.push(search);
					}
					if (this.newMessForSpisok == 'secondSpisok') {
						this.newPromo.secondSelectedIds = []
						this.newMessForSpisok == ''
						this.check = true;
						await this.secondSearchCollect.plus.push(search);
					}
					if (this.newMessForSpisok == 'secondMinus') {
						this.newPromo.secondItemsUnnecessary = []
						this.newMessForSpisok == ''
						this.check = false;
						this.secondSearchCollect.minus.push(search);
					}
					el.forEach(element => {
						if (!this.newPromo.selectedIds.includes(element.wrappedId) && this.newMessForSpisok == 'plus') {
							this.newPromo.selectedIds.push(element.wrappedId)
						}
						// if (!this.newPromo.secondSelectedIds.includes(element.wrappedId) && this.newMessForSpisok == 'secondSpisok') {
						// 	this.newPromo.secondSelectedIds.push(element.wrappedId)
						// }
						if (!this.newPromo.itemsUnnecessary.includes(element.wrappedId) && this.newMessForSpisok == 'minus') {
							this.newPromo.itemsUnnecessary.push(element.wrappedId)
						}

					});
					let data = {
						plus: this.searchCollect.plus,
						minus: this.searchCollect.minus,
					}
					let secondData = {
						plus: this.secondSearchCollect.plus,
						minus:  this.secondSearchCollect.minus,

					}
					if (el.length >= 1) {
						if(this.newMessForSpisok == 'plus'|| this.newMessForSpisok == 'minus') {
								PromoService.savePromotionDoubleArray(data, this.searchForm, this.check).then(response => {
								this.total = response.data.total;
								this.newPromo.itemsList = response.data.items
							if (response.data.items.length > 0) {
								if (response.data.items[0].map.minus.length > 0) {
									this.searchCollect.minus = response.data.items[0].map.minus
									this.dobavitDisabledButton = true;

								}
								if (response.data.items[0].map.plus.length > 0) {
									this.searchCollect.plus = response.data.items[0].map.plus
									this.nvSpiskaDisabledButton = false;
								}
								this.refreshDisabledButton = false;
							}
							this.childModal = false
							});
						}
						if(this.newMessForSpisok == 'secondSpisok' || this.newMessForSpisok == 'secondMinus') {
							PromoService.savePromotionDoubleArray(secondData, this.searchSecondForm, this.check).then(response => {
								this.secondPagTotal = response.data.total;
								this.newPromo.secondItemsList = response.data.items
							if (response.data.items.length > 0) {
								if (response.data.items[0].map.minus.length > 0) {
									this.secondSearchCollect.minus = response.data.items[0].map.minus
									this.dobavitDisabledButtonSecond = true;

								}
								if (response.data.items[0].map.plus.length > 0) {
									this.secondSearchCollect.plus = response.data.items[0].map.plus
									this.nvSpiskaDisabledButtonSecond= false;
								}
								this.refreshDisabledButtonSecond = false;
							}
							this.childModal = false
						});
						}
					}
				}
				if (this.mode == 'edit') {
					let data = {
						plus: this.searchCollect.plus,
						minus: this.searchCollect.minus,
					}
					let secondData = {
						plus: this.secondSearchCollect.plus,
						minus:  this.secondSearchCollect.minus,
					}
					if (this.newMessForSpisok == 'plus' ) {
						this.searchCollect.plus.push(search);
						PromoService.updateCollectPlusArray(data, this.searchForm).then(response => {
							this.promotionPlusForUpdate = response.data.items;
							this.mapIds.plusIds = response.data.items[0].itemIds
							this.totalPlus = response.data.total;
							this.refreshDisabledButton = false;
							this.childModal = false
						})
					}
					if (this.newMessForSpisok == 'minus') {
						this.searchCollect.minus.push(search);
						PromoService.updateCollectMinusArray(data, this.searchForm).then(response => {
							this.promotionMinusForUpdate = response.data.items;
							this.mapIds.minusIds = response.data.items[0].itemIds
							this.totalMinus = response.data.total;
							this.refreshDisabledButton = false;
							this.childModal = false
						})
					}

					//buy x get y
					if (this.newMessForSpisok == 'secondSpisok' ) {
						this.secondSearchCollect.plus.push(search);
						PromoService.updateCollectPlusArray(secondData, this.searchSecondForm).then(response => {
							this.promotionSecondPlusForUpdate = response.data.items;
							this.secondMapIds.plusIds = response.data.items[0].itemIds
							this.secondTotalPlus = response.data.total;
							this.refreshDisabledButtonSecond = false;
							this.childModal = false

						})
					}
					if (this.newMessForSpisok == 'secondMinus') {
						this.secondSearchCollect.minus.push(search);
						PromoService.updateCollectMinusArray(secondData, this.searchSecondForm).then(response => {
							this.promotionSecondMinusForUpdate = response.data.items;
							this.secondMapIds.minusIds = response.data.items[0].itemIds
							this.secondTotalMinus = response.data.total;
							this.refreshDisabledButtonSecond = false;
							this.childModal = false

						})
					}

				}
				if (el.length <= 0) {
					this.$vs.notify({
						text: 'Пожалуйста поиск Товары',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					this.childModal = true
				}


				// if (this.newMessForSpisok == 'new') {
				// 	this.newPromo.itemsList = [];
				// 	this.newPromo.itemIds = [...this.newPromo.selectedIds];
				// 	this.searchDoubleDiscountStore(this.newPromo);
				// 	if (this.searchDoubleDiscount.length > 0) {
				// 		this.newPromo.itemsList = await [...this.searchDoubleDiscount];
				// 		this.newMessForSpisok = '';
				// 	}
				// }

			},
			closeAddItemsModal() {
				if (this.mode == 'create') {
					let data = {
						plus: this.searchCollect.plus,
						minus: this.searchCollect.minus,
					};
					let secondData = {
						plus: this.secondSearchCollect.plus,
						minus: this.secondSearchCollect.minus
					}
					if (data.plus.length > 0) {
							if(this.newMessForSpisok == 'plus' || this.newMessForSpisok == 'minus') {
								PromoService.savePromotionDoubleArray(data, this.searchForm, this.check).then(response => {
									this.total = response.data.total;
									this.newPromo.itemsList = response.data.items
								if (response.data.items.length > 0) {
									this.searchCollect.minus = response.data.items[0].map.minus
									this.searchCollect.plus = response.data.items[0].map.plus
									this.childModal = false
								}
								});
							}
							this.childModal = false

					} else {
						this.newPromo.itemsList = [];
						this.childModal = false
					}
					// secondTable
					if (secondData.plus.length > 0) {
						if(this.newMessForSpisok == 'secondSpisok' || this.newMessForSpisok == 'secondMinus') {
							PromoService.savePromotionDoubleArray(secondData, this.searchSecondForm, this.check).then(response => {
								this.secondPagtotal = response.data.total;
								this.newPromo.secondItemsList = response.data.items
							if (response.data.items.length > 0) {
								this.secondSearchCollect.minus = response.data.items[0].map.minus
								this.secondSearchCollect.plus = response.data.items[0].map.plus
								this.childModal = false
								}
							});
						}
						this.childModal = false
					} else {
						this.newPromo.secondItemsList = [];
						this.childModal = false
					}

				}
				if (this.mode == 'edit') {
					this.childModal = false

				}

			},
			removeItem($event) {
				this.newPromo.itemsList.map((item, i) => {
					if (item.wrappedId === $event.wrappedId) {
						this.newPromo.itemsList.splice(i, 1);
					}
				})
				this.newPromo.selected.map((item, i) => {
					if (item.wrappedId === $event.wrappedId) {
						this.newPromo.selected.splice(i, 1);
					}
				})
				this.newPromo.selectedIds.map((value, key) => {
					if (value === $event.wrappedId) {
						this.newPromo.selectedIds.splice(key, 1);
					}
				})


			},


		},
		created() {
			// this.fetchDepartment()
			this.fetchMyDepartments();
			this.getReferenceChildren("Promotion_type")
			if (this.mode === 'create') {
				this.nvSpiskaDisabledButton = true;
				this.nvSpiskaDisabledButtonSecond = true;
				this.dobavitDisabledButton = false;
				this.dobavitDisabledButtonSecond = false;
				this.newPromo = this.createPromo
				// this.totalForEdit = 0;
				// this.secondTotalForEdit = 0
			} else {
				this.promotionId
				let obj = Object.assign({}, this.edit)
				obj.selected = []
				obj.selectedIds = []
				obj.selectedPromoGet = []
				obj.selectedPromoIds = []
				this.edit.itemsList.forEach(item => {
					obj.selected.push({
						wrappedId: item.id,
						colorName: item.colorName,
						artikul: item.artikul,
						model: item.model,
						sku: item.sku,
						barcode: item.barcode,
						size: item.size,
						name: item.name,
					})
					obj.selectedIds.push(item.id)
				})
				obj.itemsList = obj.selected
				obj.secondItemsList = obj.selectedPromoGet;
				this.edit.promoGet.itemsList.forEach(item => {
						obj.selectedPromoGet.push({
						wrappedId: item.id,
						colorName: item.colorName,
						artikul: item.artikul,
						model: item.model,
						sku: item.sku,
						barcode: item.barcode,
						size: item.size,
						name: item.name,
					})
					obj.selectedPromoIds.push(item.id)
				})
				// this.promotionPlusForUpdate = obj.itemsList;
				obj.deps = obj.departmentsList
				obj.promoGet.promotionType = obj.promoGet.promotionType === "%" ? "PERCENTAGE" : obj.promoGet.promotionType,
				this.newPromo = obj;
				this.newPromo.qty = obj.quantity;
				this.newPromo.discount = obj.promoGet.discount;
				this.newPromo.getQty = obj.promoGet.quantity
				this.newPromo.promotionType = obj.promoGet.promotionType
				this.nvSpiskaDisabledButton = false;
				this.nvSpiskaDisabledButtonSecond = false;
				this.dobavitDisabledButton = false;
				this.dobavitDisabledButtonSecond = false;
			}


		},
		computed: {
			secondPromoType() {
				return this.promoType.filter((e) => {
					return e.code != '1+1' && e.code != '2+1'
				})
			},
			listWarehouse() {
				return this.myDepartments.filter(item => {
					return item;
				})
			},
			...mapGetters('promo', {
				'allDeps': 'getDeps'
			}),
			...mapGetters('departments', [
				'myDepartments'
			]),
			...mapState('references', {
				'promoType': 'refPaymentType'
			}),
			...mapState('promo', [
				'searchDoubleDiscount', 'promotionId', 'buyXgetYPromotionId'
			]),
		},
		watch: {
			'searchForm.page': {
				async handler() {
					let data = {
						plus: this.searchCollect.plus,
						minus: this.searchCollect.minus,
					}
					if (this.mode == 'create') {
						PromoService.savePromotionDoubleArray(data, this.searchForm).then(response => {
							this.newPromo.itemsList = response.data.items
							this.total = response.data.total;
							this.responseArray = response.data;
							// this.$emit('success', true);
						});
					}

					if (this.mode == 'edit') {
						if (this.newMessForSpisok !== 'minus' && this.newMessForSpisok !== 'plus') {
							PromoService.buyXForPagination(this.buyXgetYPromotionId, this.searchForm.page, this.searchForm.limit).then(response => {
									this.newPromo.itemsList = response.data.itemList
									this.totalForEdit = response.data.total;
									this.responseArray = response.data;
									// this.$emit('success', true);
								}
							);
						}
						if (this.newMessForSpisok == 'minus') {
							PromoService.updateCollectMinusArray(data, this.searchForm).then(response => {
								this.promotionMinusForUpdate = response.data.item;
								this.mapIds.minusIds = response.data.items[0].itemIds
								this.totalMinus = response.data.total;
								this.childModal = false

							})


						}
					}
				}
			},
			'searchSecondForm.page': {
				handler() {
					let secondData = {
						plus: this.secondSearchCollect.plus,
						minus: this.secondSearchCollect.minus,
					}
					if (this.mode == 'create') {
						PromoService.savePromotionDoubleArray(secondData, this.searchSecondForm).then(response => {
							this.newPromo.secondItemsList = response.data.items
							this.secondPagTotal = response.data.total;
							this.responseArray = response.data;

							// this.$emit('success', true);
						});
					}
					if (this.mode == 'edit') {
						if (this.newMessForSpisok !== 'secondMinus' && this.newMessForSpisok !== 'secondSpisok') {
							PromoService.getYForPagination(this.buyXgetYPromotionId, this.searchSecondForm.page, this.searchSecondForm.limit).then(response => {
									this.newPromo.secondItemsList = response.data.itemList
									this.secondTotalForEdit = response.data.total;
									this.responseArray = response.data;
									// this.$emit('success', true);
								}
							);
						}
						if (this.newMessForSpisok == 'secondMinus') {
							PromoService.updateCollectMinusArray(secondData, this.searchSecondForm).then(response => {
								this.promotionSecondMinusForUpdate = response.data.items;
								this.secondMapIds.minusIds = response.data.items[0].itemIds
								this.secondotalMinus = response.data.total;
								this.childModal = false
							})
						}
					}
				}
			},

			'searchFormPlus.page': {
				handler(newValue) {
					let data = {
						plus: this.searchCollect.plus,
						minus: this.searchCollect.minus,
					}
					if (newValue > 1) {
						PromoService.updateCollectPlusArray(data, this.searchFormPlus).then(response => {
							this.promotionPlusForUpdate = response.data.items;
							this.mapIds.plusIds = response.data.items[0].itemIds
							this.totalPlus = response.data.total;

						})
					}
				}
			},

			'searchSecondFormPlus.page': {
				handler(newValue) {
					let data = {
						plus: this.secondSearchCollect.plus,
						minus: this.secondSearchCollect.minus,
					}
					if (newValue > 1) {
						PromoService.updateCollectPlusArray(data, this.searchSecondFormPlus).then(response => {
							this.promotionSecondPlusForUpdate = response.data.items;
							this.secondMapIds.plusIds = response.data.items[0].itemIds
							this.secondTotalPlus = response.data.total;

						})
					}
				}
			},

			'searchFormMinus.page': {
				handler(newValue) {
					let data = {
						plus: this.searchCollect.plus,
						minus: this.searchCollect.minus,


					}
					if (newValue > 1) {
						PromoService.updateCollectMinusArray(data, this.searchFormMinus).then(response => {
							this.promotionMinusForUpdate = response.data.items;
							this.mapIds.minusIds = response.data.items[0].itemIds
							this.totalMinus = response.data.total;
						})
					}
				}
			},
			'searchSecondFormMinus.page': {
				handler(newValue) {
					let data = {
						plus: this.secondSearchCollect.plus,
						minus: this.secondSearchCollect.minus,


					}
					if (newValue > 1) {
						PromoService.updateCollectMinusArray(data, this.searchSecondFormMinus).then(response => {
							this.promotionSecondMinusForUpdate = response.data.items;
							this.secondMapIds.minusIds = response.data.items[0].itemIds
							this.secondTotalMinus = response.data.total;
						})
					}
				}
			}

		}
		,

		components: {
			AddChildren,
			MaskedInput,
			Multiselect
		}
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
	#newPromoId {
		.form-group {
			margin-bottom: .5rem;
		}
	}

	.invalid .multiselect__tags {
		border-color: red;
	}

	.addItemsModalHeader {
		display: flex;
		width: 100%;
		justify-content: space-between;

		.close {
			font-size: 18px;
		}
	}
</style>

